import { TZendeskWebWidgetType } from '../zendesk.t';
import { ZENDESK_WEB_WIDGET_TYPES } from '../zendeskConstants';
import ZendeskWebWidgetStandard from '../widgets/ZendeskWebWidgetStandard';
import ZendeskWebWidgetClassic from '../widgets/ZendeskWebWidgetClassic';

function getZendeskWidgetInstanceByType(type: TZendeskWebWidgetType) {
    switch (type) {
        case ZENDESK_WEB_WIDGET_TYPES.CLASSIC:
            return new ZendeskWebWidgetClassic();
        case ZENDESK_WEB_WIDGET_TYPES.STANDARD:
        default:
            return new ZendeskWebWidgetStandard();
    }
}

export default getZendeskWidgetInstanceByType;
